export class AppConsts {
  static apiBaseUrl: string = 'http://161.97.137.187:2004';
  static remoteServiceBaseUrl: string = 'http://161.97.137.187:2004';
  static appBaseUrl: string = 'http://localhost:4200';
  static googleMapApiKey: string = 'AIzaSyBqaAfWMXN6tKz_nEiIJ0nk94DeW3bYm6o';
  static appConfig: string = 'appconfig.json';
  [key: string]: any;
}

export const AppConst = AppConsts;
